__turbopack_context__.v({
  "rating": "_1lztDa_rating",
  "typeNeutral": "_1lztDa_typeNeutral",
  "typeYellow": "_1lztDa_typeYellow",
});
